import axios from '../axios';

export default async (ids) => {
    let response = await axios.post(`/api/userFromId`, {
        ids: ids
    })
    let result = await response.data;
    return result.data;
}